import { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../AuthContext.jsx';
import { supabase } from '../supabase.js';
import { formatMessageTime, listMyConversations } from './messages.js';
import { Thread } from './Thread.jsx';
import { SignInGate } from '../SignIn.jsx';

/** /messages lists conversations; /messages/:id opens one. Route both paths to this page. */
export default function MessagesPage() {
  const { id } = useParams();
  const { user, loading } = useAuth();
  if (loading) return <div className="content-wrap"><p>Loading account…</p></div>;
  if (!user || !supabase) return <SignInGate next={id ? `/messages/${id}` : '/messages'}/>;
  return <div className="content-wrap account-page" key={user.id}>{id ? <Conversation id={id} /> : <Inbox />}</div>;
}

function Inbox() {
  const [rows, setRows] = useState(null), [error, setError] = useState('');
  const load = useCallback(() => listMyConversations(supabase).then(value => { setRows(value); setError(''); }).catch(cause => setError(cause.message)), []);
  useEffect(() => { void load(); }, [load]);
  return <>
    <header className="coord-page-heading"><div><span className="account-kicker">MESSAGES</span><h1>Messages</h1></div></header>
    {error ? <div role="alert"><p>{error}</p><button type="button" className="button button-secondary" onClick={load}>Try again</button></div>
      : rows === null ? <p>Loading messages…</p>
        : rows.length === 0 ? <p>No messages yet. You can message a supplier about their bid, or a customer after you bid on their job.</p>
          : <ul className="account-content-panel" style={{ listStyle: 'none', display: 'grid', gap: 12 }}>{rows.map(row => <li key={row.id}>
            <Link to={`/messages/${row.id}`}><strong>{row.other_name}</strong></Link>
            {row.unread_count > 0 && <span className="status-pill" style={{ marginLeft: 8 }}>{row.unread_count} unread</span>}
            <div><small>{row.title}{row.last_message && ` · ${formatMessageTime(row.last_message.created_at)}`}</small></div>
            <div>{row.last_message ? `${row.last_message.is_mine ? 'You: ' : ''}${row.last_message.body}` : 'No messages yet'}</div>
          </li>)}</ul>}
  </>;
}

function Conversation({ id }) {
  return <>
    <p><Link to="/messages">All messages</Link></p>
    <section className="account-content-panel"><Thread conversationId={id} /></section>
  </>;
}
